'use strict';

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const DutyViewModel=require('../../../../dist-es6/client/viewModels/dutyViewModel');
const getTextWidth=require('../../../../dist-es6/client/utilities/getTextWidth');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');

const MinimumIntervalWidthInPixels=2;
const DefaultAxisLabelMargin=14;let

IntervalPlotterDirective=class IntervalPlotterDirective extends BaseControllerBackedDirective{
get objectBindings(){
return['intervals','intervalHeight','labelFormatter','plotArea','horizontalAxis','labelFontStyle','verticalMargin','horizontalMargin','intervalTopY','doNotClip','alwaysRedraw','selectedInterval'];
}
get textBindings(){
return['class','intervalColor','mask','leftAxisLabel','leftAxisLabelMargin'];
}

get controller(){
return IntervalPlotterController;
}};let


IntervalPlotterController=class IntervalPlotterController{
static get $inject(){
return['$scope','$element','$compile'];
}

constructor($scope,$element,$compile){
this._labelMargin={
top:1,
left:4};


this._$scope=$scope;
this._$element=$element;
this._$compile=$compile;

this.labelFontSize=_.exists(this.labelFontStyle)?Number.parseInt(this.labelFontStyle.split(' ')[1].split('px')[0]):void 0;
this.leftAxisLabelMargin=_.exists(this.leftAxisLabelMargin)?parseInt(this.leftAxisLabelMargin,10):DefaultAxisLabelMargin;
this.alwaysRedraw=_.exists(this.alwaysRedraw)?!!this.alwaysRedraw:!1;

$scope.$watch('controller.plotArea',()=>{
if(_.exists(this.plotArea)){
this.plotArea.registerPlotter(this);
}
});


if(this.selectedInterval!==void 0){
$scope.$watch('controller.selectedInterval',newInterval=>{
for(const int of _.flatten(this._plottedIntervals)){
d3.select(int).
classed('selected',_.get(int,'__data__.interval')===newInterval);
}
});
}
}

get _baseTooltipAttributes(){
return{
"pulsar-tooltip":!0,
"pulsar-tooltip-anchor":i=>_getTooltipAnchorSide(i,'left','bottomLeft'),
"pulsar-tooltip-align-from":i=>_getTooltipAnchorSide(i,'right','topLeft'),
"pulsar-tooltip-left-offset":i=>this.doNotClip&&i.xPos<this.horizontalAxis.offset?this.horizontalAxis.offset-i.xPos:0,
"pulsar-tooltip-text":intervalInfo=>intervalInfo.label};

}

get _baseRectangleAttributes(){
return{
tabindex:-1,
x:intervalInfo=>this.doNotClip?intervalInfo.xPos:Math.max(intervalInfo.xPos,this.horizontalAxis.offset),
width:intervalInfo=>intervalInfo.width};

}

get _baseTextLabelAttributes(){
return{
"font-size":`${this.labelFontSize}px`,
"line-height":'2ex'};

}

_plotIntervals(element,intervalInfo){
let withoutToolTips=element.selectAll(`rect`).
data(intervalInfo).
enter().
append(`rect`).
attr(this._baseRectangleAttributes);
return _.exists(this.labelFormatter)?
withoutToolTips.attr(this._baseTooltipAttributes):
withoutToolTips;
}

_insertTspans(intervalInfo){
let lines=intervalInfo.label.split('\n');
if(lines!==void 0){
let textElement=d3.select(this);
let margin=5;

let widthOfLargestLine=_.max(lines.map(l=>getTextWidth(l,this.labelFontStyle)))+margin*2;
let xPlacement=Math.min(Math.max(intervalInfo.xPos,0),intervalInfo.svgWidth-widthOfLargestLine);
let xPosDifference=intervalInfo.xPos<0?intervalInfo.xPos:0;

let classes=[];

if(widthOfLargestLine-xPosDifference>intervalInfo.widthOnScreen||xPlacement<textElement.attr('x')){
classes.push('hide');
classes.push('too-long');
}

for(let i=0;i<lines.length;i++){
textElement.append('tspan').
text(lines[i]).
attr('x',xPlacement).
attr('dy',i>0?'1.2em':0).
attr('class',classes.join(' '));
}
}
}

_plotLabels(element,intervalInfo){
return element.selectAll('text').
data(intervalInfo).
enter().
append('text').
attr(this._baseRectangleAttributes).
style(this._baseTextLabelAttributes).
each(this._insertTspans);
}

get _horizontalMargin(){
return this.horizontalMargin?this.horizontalMargin:0;
}

redraw(){
if(!_.exists(this.horizontalAxis)||!_.exists(this.horizontalAxis.scale)){
return;
}

const svgContainer=d3.select(this.plotArea.svgElement);
const intervalGroup=svgContainer.append('g').attr({
class:this.class,
transform:`translate(0, ${this.plotArea.graphAreaBoundaries.top})`,
mask:`url(#${this.mask}-${this.plotArea.id})`});


let actualIntervalHeight=_.exists(this.intervalHeight)?
this.intervalHeight:
this.plotArea.graphAreaDimensions.height;

let intervalTopY=this.plotArea.graphAreaDimensions.height-actualIntervalHeight;

if(_.exists(this.intervalTopY)){
actualIntervalHeight-=this.intervalTopY;
intervalTopY=this.intervalTopY;
}

if(_.exists(this.verticalMargin)){
actualIntervalHeight-=this.verticalMargin*2;
intervalTopY+=this.verticalMargin;
}

if(_.exists(this.leftAxisLabel)&&this.leftAxisLabel!==''){
intervalGroup.
append('text').
attr({
y:intervalTopY+actualIntervalHeight/2,
x:0,
class:'interval-axis-label'}).

text(this.leftAxisLabel);
}

const initialIntervals=_.isArray(this.intervals)?this.intervals:_.compact([this.intervals]);

const intervals=_.flatMap(initialIntervals,i=>i instanceof DutyViewModel?i.asSplitIntervals():[i]);

if(!_.exists(intervals)||intervals.length===0){
return;
}

let intervalInfos=intervals.map(interval=>{
const xPos=this.horizontalAxis.scale(interval.start.getTime())+this._horizontalMargin;
const xEnd=this.horizontalAxis.scale(interval.end.getTime())-this._horizontalMargin;
const widthOnScreen=Math.max(xEnd-xPos,MinimumIntervalWidthInPixels);
const svgWidth=this.plotArea.dimensions.width;

const width=this.doNotClip?widthOnScreen:xPos<this.horizontalAxis.offset?
widthOnScreen+xPos-this.horizontalAxis.offset:
xPos+widthOnScreen>svgWidth?
svgWidth-xPos:
widthOnScreen;

const info={
interval:interval,
xPos:xPos,
widthOnScreen,
width,
svgWidth,
fontSize:this.labelFontSize};

if(_.exists(this.labelFormatter)){
info.label=this.labelFormatter(interval);
}
return info;
}).filter(intervalInfo=>intervalInfo.width>=0);

this._plottedIntervals=this._plotIntervals(intervalGroup,intervalInfos).
attr({
height:actualIntervalHeight,
y:intervalTopY,
class:data=>_.get(data,'interval.customClass',this.class)});


if(this.selectedInterval!==void 0){
const _self=this;
this._plottedIntervals.on('focus',function(d){
_self._$scope.$evalAsync(()=>{
_self.selectedInterval=d.interval;
});
});
}

if(_.exists(this.intervalColor)){
this._plottedIntervals.style('fill',this.intervalColor);
}

if(_.exists(this.labelFontStyle)&&_.exists(this.labelFormatter)){
this._plotLabels(intervalGroup,intervalInfos).
attr({
class:`${this.class}-label`,
transform:`translate(${this._labelMargin.left}, ${intervalTopY+this._labelMargin.top+this.labelFontSize})`});

}

if(this._childScope){
this._childScope.$destroy();
}

this._childScope=this._$scope.$new();

this._compiledHtml=this._$compile(this.plotArea.svgElement)(this._childScope);
}};


const _getTooltipAnchorSide=(intervalInfo,nearEdgeSide,defaultSide)=>
intervalInfo.xPos/intervalInfo.svgWidth>0.85||intervalInfo.xPos>350&&intervalInfo.svgWidth-intervalInfo.xPos<350?
nearEdgeSide:
defaultSide;

module.exports=IntervalPlotterDirective;
//# sourceMappingURL=intervalPlotterDirective.js.map
